// -----------------------------------------------------------
// FloraIQ — Aba Nuvem de Pontos (Validação)
// -----------------------------------------------------------

import { pointCloudIssues } from "@/mocks/quality";
import { SeverityBadge, ValidationStatusBadge } from "./QualityStatusBadge";

export default function PointCloudValidationPanel() {
  const metadadosOk = 21;
  const semSrid = pointCloudIssues.filter((p) => p.metadadoAusente.includes("SRID")).length;
  const semVinculo = pointCloudIssues.filter((p) => p.metadadoAusente.includes("Vínculo")).length;
  const divergencias = pointCloudIssues.filter((p) => p.ativo3d.includes("Divergência")).length;
  const semEvento = pointCloudIssues.filter((p) => p.metadadoAusente.includes("Evento")).length;

  return (
    <div className="space-y-6">
      {/* Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {[
          { label: "Metadados Completos", value: metadadosOk, icon: "ri-check-double-line", color: "green" },
          { label: "LAS/LAZ sem SRID", value: semSrid, icon: "ri-global-line", color: "red" },
          { label: "Métricas sem Vínculo", value: semVinculo, icon: "ri-link-unlink", color: "orange" },
          { label: "Divergências sem Validação", value: divergencias, icon: "ri-contrast-2-line", color: "orange" },
          { label: "Eventos 3D Não Versionados", value: semEvento, icon: "ri-history-line", color: "yellow" },
        ].map((p) => (
          <div key={p.label} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${
                p.color === "green" ? "bg-green-100 text-green-600" : p.color === "red" ? "bg-red-100 text-red-600" : p.color === "orange" ? "bg-orange-100 text-orange-600" : "bg-yellow-100 text-yellow-600"
              }`}>
                <i className={`${p.icon} text-xs`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-600 truncate">{p.label}</span>
            </div>
            <p className="text-lg font-bold font-heading text-foreground-900">{p.value}</p>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Ativo 3D</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Projeto</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Metadado Ausente</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Métrica Afetada</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Severidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Status</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Ação Recomendada</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Ações</th>
            </tr>
          </thead>
          <tbody>
            {pointCloudIssues.map((p) => (
              <tr key={p.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-mono text-foreground-700">{p.ativo3d}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[140px] truncate">{p.projeto}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[200px] truncate">{p.metadadoAusente}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[180px] truncate">{p.metricaAfetada}</td>
                <td className="px-3 py-2.5"><SeverityBadge severity={p.severidade} /></td>
                <td className="px-3 py-2.5"><ValidationStatusBadge status={p.status} /></td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[220px] truncate">{p.acaoRecomendada}</td>
                <td className="px-3 py-2.5 text-center">
                  <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Abrir 3D">
                    <i className="ri-stack-line text-foreground-500 text-sm"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}